import { Spacer } from '@sparemin/blockhead';
import React from 'react';
import { block } from './utils';

export interface AnimationControlsContainerProps {
  children?: React.ReactNode;
}

const AnimationControlsContainer: React.FC<AnimationControlsContainerProps> = ({
  children,
}) => {
  return (
    <Spacer
      orientation="vertical"
      space="16px"
      align="center"
      justify="center"
      className={block('animation-controls-container')}
    >
      {children}
    </Spacer>
  );
};

export default AnimationControlsContainer;
